import React from "react";
import { ICON_PATHS } from "./paths.js";

// Rend le même trait que ic() dans design/kit.mjs : grille 24×24, currentColor,
// stroke-width 1.75 par défaut. Aucune bibliothèque d'icônes tierce — c'est
// volontaire, pour rester identique aux maquettes validées.
const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.75, className, ...props }) => {
  const chemin = ICON_PATHS[name];
  if (!chemin) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(`Icon: "${name}" n'existe pas dans design/kit.mjs`);
    }
    return null;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path d={chemin} />
    </svg>
  );
};

export default Icon;
